import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CommonCd } from '../common-cd/CommonCd';
import { HospitalInfo } from '../hospital-info/HospitalInfo';

/**
 * # User
 *
 * 사용자 정보 모델
 */

export const User = types
  .model('User')
  // --------------------------------------------------------------------------
  .props({
    userSid: types.number,
    loginId: types.maybeNull(types.string),
    pwd: types.maybeNull(types.string),
    userNm: types.maybeNull(types.string),
    phoneNo: types.maybeNull(types.string),
    birthday: types.maybeNull(types.string),
    ci: types.maybeNull(types.string),
    genderTypeCd: types.maybeNull(CommonCd),
    userTypeCd: types.maybeNull(CommonCd),
    quitDt: types.maybeNull(types.string),
    acntSttsCd: types.maybeNull(CommonCd),
    acntSttsDt: types.maybeNull(types.string),
    loginFailCnt: types.maybeNull(types.number),
    pwdUpdDt: types.maybeNull(types.string),
    lastLoginDt: types.maybeNull(types.string),
    regDt: types.maybeNull(types.string),
    updDt: types.maybeNull(types.string),
    prescriptionId: types.maybeNull(types.string),
    hsptlSid: types.maybeNull(types.number),
    hsptlInfo: types.maybeNull(HospitalInfo),
    age: types.maybeNull(types.number),
    quitSmokingDay: types.maybeNull(types.number),
    verifyKey: types.maybeNull(types.string),
    newPwd: types.maybeNull(types.string),
    confirmPwd: types.maybeNull(types.string),
    langCd: types.maybeNull(types.string),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model user --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IUser;
      (Object.keys(newProps) as TUserKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TUser = Instance<typeof User>;
type TUserSnapshot = SnapshotOut<typeof User>;

export interface IUser extends TUser {}
export type TUserKeys = keyof TUserSnapshot & string;
export interface IUserSnapshot extends TUserSnapshot {}
export const createUser = () => types.optional(User, {} as TUser);
